<template>
  <v-dialog
    :value="value"
    :width="width"
    :persistent="persistent"
    @keydown.esc="clickCancel"
    :max-width="maxWidth"
    :max-height="maxHeight"
  >
    <v-card>
      <v-card-title :style="isTitleDesplay ? '' : 'display: none'">
        <span class="headline">
          {{ title }}
        </span>
      </v-card-title>
      <v-card-text
        :style="
          'min-height: ' + minHeight + ';' + 'padding: ' + cardTextPadding
        "
      >
        <slot />
      </v-card-text>
      <v-card-actions
        :style="isActionsDesplay ? '' : 'display: none'"
        :class="actionsShadow ? 'card-actions' : ''"
      >
        <div
          v-if="helpPageUrl"
          style="display: flex; align-items: center; margin-left: 16px;"
        >
          <v-icon @click="openHelpPage()" color="primary"
            >mdi-help-circle</v-icon
          >
          <span
            @click="openHelpPage()"
            style="font-size: 16px; margin-left: 8px; cursor: pointer; color: #007bff; text-decoration:underline;"
          >
            {{ helpPageTitle }}
          </span>
        </div>
        <v-spacer />
        <v-btn
          v-if="showCancelButton"
          :disabled="loading"
          @click.native="clickCancel"
          color="normal"
        >
          {{ cancelButtonText }}
        </v-btn>
        <v-btn
          v-if="showExecButton"
          :loading="loading"
          :disabled="isExecButtonDisabled"
          @click.native="$emit('clickExec')"
          color="primary"
        >
          {{ execButtonText }}
        </v-btn>
      </v-card-actions>
      <v-flex
        style="
          position: absolute;
          right: 0;
          top: 0;
          z-index: 100
        "
      >
        <v-btn
          v-if="showCloseButton"
          :disabled="loading"
          @click.native="clickCancel"
          style="
            width: 30px;
            height: 30px;
            margin: 5px 5px;
            min-width: 0;
            background-color: white;
            box-shadow: none;
          "
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-flex>
    </v-card>
    <AppEditConfirmModal
      :value="isOpenConfirmModal"
      @clickOk="onClickConfirmOk"
      @clickNg="onClickConfirmNg"
    />
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '80vw',
    },
    maxWidth: {
      type: String,
      default: '1600px',
    },
    minHeight: {
      type: String,
      default: '72vh',
    },
    maxHeight: {
      type: String,
      default: '90vh',
    },
    cardTitlePadding: {
      type: String,
      default: '16px',
    },
    cardTextPadding: {
      type: String,
      default: '16px',
    },
    isTitleDesplay: {
      type: Boolean,
      default: true,
    },
    isTextDesplay: {
      type: Boolean,
      default: true,
    },
    isActionsDesplay: {
      type: Boolean,
      default: true,
    },
    showExecButton: {
      type: Boolean,
      default: true,
    },
    showCancelButton: {
      type: Boolean,
      default: true,
    },
    showCloseButton: {
      type: Boolean,
      default: false,
    },
    isExecButtonDisabled: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    helpPageTitle: {
      type: String,
      default: 'ヘルプ',
    },
    helpPageUrl: {
      type: String,
      default: undefined,
    },
    cancelButtonText: {
      type: String,
      default: 'キャンセル',
    },
    execButtonText: {
      type: String,
      default: '保存',
    },
    confirmOnClickCancel: {
      type: Boolean,
      default: true,
    },
    persistent: {
      type: Boolean,
      default: true,
    },
    actionsShadow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpenConfirmModal: false,
    }
  },
  methods: {
    async clickCancel() {
      if (this.confirmOnClickCancel) {
        this.openConformModal()
      } else {
        this.excecCancel()
      }
    },
    excecCancel() {
      this.$emit('clickCancel')
      this.$emit('cancel')
      this.$emit('input', false)
    },
    // confirm componentの開閉
    async confirmCancel() {
      this.isOpenConfirmModal = true
    },
    closeConformModal() {
      this.isOpenConfirmModal = false
    },
    openConformModal() {
      this.isOpenConfirmModal = true
    },
    onClickConfirmOk() {
      this.closeConformModal()
      this.excecCancel()
    },
    onClickConfirmNg() {
      this.closeConformModal()
    },
    openHelpPage() {
      window.open(this.helpPageUrl, '_blank', 'noreferrer')
    },
  },
}
</script>

<style>
.card-actions {
  box-shadow: 0 -5px 10px #dddddd;
}
</style>
